module.exports = __webpack_public_path__ + "img/screenshot_3.64c366d2.jpg";